import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { syaratKetentuanSections } from "../syaratKetentuanContent";

const SyaratKetentuanDocument = () => {
    return (
        <Box component="main">
            <Container maxWidth="xl">
                <Typography
                    component="h1"
                    color="#464646"
                    fontWeight={700}
                    fontSize={32}
                    sx={{ mt: 5, mb: 2 }}
                >
                    Syarat dan Ketentuan ULO
                </Typography>

                <Box width="100%">
                    {syaratKetentuanSections.map((section, sectionIndex) => (
                        <Box key={section.title}>
                            <Typography
                                component="h2"
                                color="#464646"
                                fontWeight={700}
                                fontSize={section.headingSize}
                                sx={{
                                    mt: sectionIndex === 0 ? 0 : 3,
                                    mb: sectionIndex === 0 ? 1 : 2,
                                }}
                            >
                                {section.title}
                            </Typography>

                            {section.blocks.map((block, blockIndex) => (
                                <Stack
                                    key={`${section.title}-${blockIndex}`}
                                    marginTop={blockIndex === 0 ? 0 : 2}
                                    spacing={
                                        section.title ===
                                        "PENGAKUAN DAN PERSETUJUAN"
                                            ? 2
                                            : 1
                                    }
                                >
                                    {block.subtitle ? (
                                        <Typography fontWeight={600}>
                                            {block.subtitle}
                                        </Typography>
                                    ) : null}

                                    {block.paragraphs.map((paragraph, paragraphIndex) => (
                                        <Typography
                                            key={`${section.title}-${blockIndex}-${paragraphIndex}`}
                                        >
                                            {paragraph}
                                        </Typography>
                                    ))}
                                </Stack>
                            ))}
                        </Box>
                    ))}
                </Box>
            </Container>
        </Box>
    );
};

export default SyaratKetentuanDocument;
